import React from 'react';
import styled from 'styled-components';
import {
  FlexBox,
  BaseBox,
  PrimaryButton,
  SecondaryButton,
  Heading4,
  DoconModal,
  DoconModalContent,
} from '@docon/docon-ui-library';
import { WhatsAppIcon } from 'shared/icons';
import { colors } from 'utilities/colorConfig';

interface IProps {
  visible: boolean;
  onClick: (x: any) => void;
}

const Modal = styled<any>(DoconModal)`
  max-width: calc(100vw - 50px);
  border-radius: 10px;

  ${Heading4} { font-weight: bold; margin-bottom: 14px; }

  ${DoconModalContent} {
    padding: 26px 26px 22px;
    font-size: 14px;
    line-height: 20px;
    color: ${colors.primaryColor};
    text-align: center;

    button {
      margin: 0;
      flex: 1;
      font-weight: 600;
    }
  }
`;

const heading = 'Are you sure you want to opt-out?';
const text = 'You will <b>stop receiving messages</b> on WhatsApp once you disable notification settings.';

const RequestOptOut = ({
  visible,
  onClick,
}: IProps) => {

  function handleBtnClick(event: any) {
    const action = event?.currentTarget?.id;
    onClick({ action });
  }

  return (
    <Modal
      centered
      hideFooter
      hideCrossIcon
      isOpen={visible}
    >
      <WhatsAppIcon width={40} mb='10px' />
      <Heading4 title={heading} />
      <BaseBox mb={'24px'} dangerouslySetInnerHTML={{ __html: text }} />
      <FlexBox gap={'8px'}>
        <SecondaryButton
          id={'confirm'}
          size='small'
          title={'Yes, I do'}
          onClick={handleBtnClick}
        />
        <PrimaryButton
          id={'reject'}
          size='small'
          title={'No'}
          onClick={handleBtnClick}
        />
      </FlexBox>
    </Modal>
  );
};

export default RequestOptOut;